import router from '../../../router'

export default {
  SAVE_LIST(state, equipments) {
    state.equipments = equipments
  },
  DELETE(state, equipment) {
    const index = state.equipments.items.indexOf(equipment)
    state.equipments.items.splice(index, 1)
  },
}
